module.exports = __webpack_public_path__ + "static/img/67 (2).cd60898.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/67 (2).jpg
// module id = Zzk3
// module chunks = 0